import ReactGA from "../_snowpack/pkg/react-ga4.js";
export var Category;
(function(Category2) {
  Category2["Documentation"] = "Documentation";
  Category2["NativeEvent"] = "NativeEvent";
  Category2["Wizard"] = "Wizard";
  Category2["Navigation"] = "Navigation";
  Category2["Form"] = "Form";
})(Category || (Category = {}));
export const event = (category, action, label) => {
  valueEvent(category, action, label, void 0);
};
export const valueEvent = (category, action, label, value) => {
  console.log("event", category, action, label, value);
  ReactGA.event({category, action, label, value});
};
